import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import {
  Button,
  MainHeadline,
  PageWrapper,
  PageFooter,
  Flex,
} from '../../../styling/GlobalStyles'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { NavBar } from '../../../components/NavBar/NavBar'
import { Options } from 'components/Options/Options'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearInventorySuppliersList,
  deleteSupplier,
  getSuppliers,
} from 'features/supliers/suppliersSlice'
import { AppDispatch, RootState } from 'store'
import { Pagination } from 'components/Pagination/Pagination'
import { ISupplier } from 'types/suppliers.interface'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { setConfirmModal } from 'features/global/globalSlice'
import { getParams, handlePagination } from 'utils/helpers'
import { ModalTypes } from 'types/global.interface'
import useQueryPagination from 'hooks/useQueryPagination'

export const InvetorySuppliers = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { suppliers, totalPages, isLoading } = useSelector((state: RootState) => state.suppliers)
  const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))

  useQueryPagination({ fetchFunctions: [getSuppliers], cleanUpFunctions: [clearInventorySuppliersList], params })

  const statuses = ['Active', 'Inactive']

  const handleRemove = (id: number) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteSupplier(id))
        },
        word: 'delete supplier',
        setParams: {
          type: ModalTypes.Delete,
          f: setParams,
          noItems: suppliers.length < 2,
        },
      }),
    )
  }

  const columns: IHonestTableColumn<any>[] = [
    { id: 'name', header: 'Name', cell: (item) => item.name || '/' },
    { id: 'phoneNumber', header: 'Phone Number', cell: (item) => item.phoneNumber || '/' },
    { id: 'address', header: 'Address', cell: (item) => item.address || '/' },
    { id: 'vatId', header: 'VAT ID', cell: (item) => item.vatId || '/' },
    { id: 'email', header: 'Email', cell: (item) => item.email || '/' },
    {
      id: 'status',
      header: 'Status',
      cell: (item) => (
        <StatusPill status={item.status === 1 ? 'success' : 'neutral'}>
          {statuses[item.status - 1]}
        </StatusPill>
      ),
    },
    {
      id: 'actions',
      header: '',
      align: 'right',
      cell: (item) => (
        <span onClick={(e) => e.stopPropagation()}>
          <Options item={item} handleRemove={() => handleRemove(item.id)} title='Supplier' />
        </span>
      ),
    },
  ]

  return (
    <>
      <NavBar defaultValue={params.q} input placeholder='Search Suppliers...' setParams={setParams} limit={30} />
      <PageWrapper>
        <Flex between width='100%' mb='16'>
          <MainHeadline>Suppliers</MainHeadline>
          <Button onClick={() => navigate('add')} orange>
            Add Supplier
          </Button>
        </Flex>


        {suppliers.length > 0 ? (
          <HonestTable columns={columns} data={suppliers as ISupplier[]} keyField='id' />
        ) : isLoading ? (
          <></>
        ) : (
          <NoItems title='suppliers' />
        )}
      </PageWrapper>
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams, 30)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
    </>
  )
}
